import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { UnidadeService } from '../../shared/services/unidade.service';
import { Util } from '../../shared/util';

@Component({
  selector: 'sispac-informacoes-complementares',
  templateUrl: './informacoes-complementares.component.html',
  styleUrls: ['./informacoes-complementares.component.css']
})
export class InformacoesComplementaresComponent extends WebPage implements OnInit {

  unidades;
  constructor(messageService: MessageService,
      private unidadeService: UnidadeService) {
    super(messageService);
  }

  ngOnInit() {
    this.getAllUnidades();
  }

  getAllUnidades() {
    this.isLoading = true;
    this.unidadeService.getUnidadesComGestor()
    .finally(() => this.isLoading = false)
    .subscribe(
      unidades => {
        this.unidades = unidades;
        console.log(unidades);
      },
      error => this.gerenciaErro(error)
    );
  }

  formataCepLocal(cep) {
    return Util.formatAsCep(cep);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/unidade/informacoes-complementares/informacoes-complementares.component.ts